var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"px-1 py-0 my-0",attrs:{"color":_vm.color,"loading":"","disabled":"","hide-details":_vm.hideDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }